import React, { useState } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Menu, MenuItem, Button } from "@mui/material";
import Link from "@mui/material/Link";
import { useSitesPageStore } from "./sitesPageStore/sitesPageStore";
import { TenantSettingsDialog } from "./TenantSettingsDialog";

export const GroupBreadcrumbs = ({
  siteBreadcrumbs,
  setSelectedIndex,
  setPageLoading,
  getIndividualGroup,
  setRenderedRows,
  setSiteBreadcrumbs,
  setSelected,
  setEditableGroupSelected,
  setSelectedGroupListName,
  navigate,
}: {
  siteBreadcrumbs: any;
  setSelectedIndex: any;
  setPageLoading: any;
  getIndividualGroup: any;
  setRenderedRows: any;
  setSiteBreadcrumbs: any;
  setSelected: any;
  setEditableGroupSelected: any;
  setSelectedGroupListName: any;
  navigate: any;
}) => {
  const {
    setSearchGroupId,
    setSelectedGropupId,
    setSelectedGroupName,
    getTenantSettings,
    setFetchingTenantSettings,
  } = useSitesPageStore();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tenantSettingsDialogOpen, setTenantSettingsDialogOpen] =
    useState(false);
  const [selectedObject, setSelectedObject] = useState<any>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>, object: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedObject(object);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedObject(null);
  };

  const handleShowSites = (index: number) => {
    const object = siteBreadcrumbs[index + 1];
    setSelectedIndex({
      level1: [object.id],
      level2: [],
      level3: [],
      level4: [],
      level5: [],
      level6: [],
    });
    setPageLoading(true);
    localStorage.setItem("getIndividualGroupId", object.id);
    setSearchGroupId(object.id);
    getIndividualGroup(
      object.id,
      setRenderedRows,
      setPageLoading,
      setSiteBreadcrumbs,
      setSelected,
      setEditableGroupSelected,
      setSelectedGroupListName,
      navigate
    );
    handleClose();
  };

  const handleViewEditBatchSize = () => {
    setSelectedGropupId(selectedObject?.id);
    setSelectedGroupName(selectedObject?.name);
    getTenantSettings(selectedObject?.id, navigate);
    setFetchingTenantSettings(true);
    setTenantSettingsDialogOpen(true);
    handleClose();
  };

  return (
    <Stack spacing={2}>
      <div className="whitespace-nowrap flex-nowrap">
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="medium" />}
          aria-label="breadcrumb"
          sx={{
            "& .MuiBreadcrumbs-ol": {
              flexWrap: "nowrap",
              whiteSpace: "nowrap",
            },
            "& .MuiBreadcrumbs-li": {
              flexShrink: 0,
            },
          }}
        >
          {!window.location.pathname.includes("patrol") &&
            siteBreadcrumbs.map((object: any, index: any) => {
              if (index === 0 && siteBreadcrumbs.length > 1) {
                // Original link behavior for non-patrol pages
                return (
                  <Link
                    underline="hover"
                    key={index}
                    color="inherit"
                    href="/sites"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Mulish",
                      fontWeight: "bold",
                    }}
                    variant="h5"
                    onClick={(event: any) => {
                      event.preventDefault();
                      setSelectedIndex({
                        level1: [object.id],
                        level2: [],
                        level3: [],
                        level4: [],
                        level5: [],
                        level6: [],
                      });
                      setPageLoading(true);
                      localStorage.setItem("getIndividualGroupId", object.id);
                      setSearchGroupId(object.id);
                      getIndividualGroup(
                        object.id,
                        setRenderedRows,
                        setPageLoading,
                        setSiteBreadcrumbs,
                        setSelected,
                        setEditableGroupSelected,
                        setSelectedGroupListName,
                        navigate
                      );
                    }}
                  >
                    {object.name}
                  </Link>
                );
              } else if (index === 1 && siteBreadcrumbs.length > 2) {
                return (
                  <Link
                    underline="hover"
                    key={index}
                    color="inherit"
                    href="#"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Mulish",
                      fontWeight: "bold",
                    }}
                    variant="h5"
                    onClick={() => {
                      setSelectedIndex({
                        level1: [siteBreadcrumbs[0].id],
                        level2: [object.id],
                        level3: [],
                        level4: [],
                        level5: [],
                        level6: [],
                      });
                      setPageLoading(true);
                      localStorage.setItem("getIndividualGroupId", object.id);
                      setSearchGroupId(object.id);
                      getIndividualGroup(
                        object.id,
                        setRenderedRows,
                        setPageLoading,
                        setSiteBreadcrumbs,
                        setSelected,
                        setEditableGroupSelected,
                        setSelectedGroupListName,
                        navigate
                      );
                    }}
                  >
                    {object.name}
                  </Link>
                );
              } else if (index === 2 && siteBreadcrumbs.length > 3) {
                return (
                  <Link
                    underline="hover"
                    key={index}
                    color="inherit"
                    href="#"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Mulish",
                      fontWeight: "bold",
                    }}
                    variant="h5"
                    onClick={() => {
                      setSelectedIndex({
                        level1: [siteBreadcrumbs[0].id],
                        level2: [siteBreadcrumbs[1].id],
                        level3: [object.id],
                        level4: [],
                        level5: [],
                        level6: [],
                      });
                      setPageLoading(true);
                      localStorage.setItem("getIndividualGroupId", object.id);
                      setSearchGroupId(object.id);
                      getIndividualGroup(
                        object.id,
                        setRenderedRows,
                        setPageLoading,
                        setSiteBreadcrumbs,
                        setSelected,
                        setEditableGroupSelected,
                        setSelectedGroupListName,
                        navigate
                      );
                    }}
                  >
                    {object.name}
                  </Link>
                );
              } else if (index === 3 && siteBreadcrumbs.length > 4) {
                return (
                  <Link
                    underline="hover"
                    key={index}
                    color="inherit"
                    href="#"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Mulish",
                      fontWeight: "bold",
                    }}
                    variant="h5"
                    onClick={() => {
                      setSelectedIndex({
                        level1: [siteBreadcrumbs[0].id],
                        level2: [siteBreadcrumbs[1].id],
                        level3: [siteBreadcrumbs[2].id],
                        level4: [object.id],
                        level5: [],
                        level6: [],
                      });
                      setPageLoading(true);
                      localStorage.setItem("getIndividualGroupId", object.id);
                      setSearchGroupId(object.id);
                      getIndividualGroup(
                        object.id,
                        setRenderedRows,
                        setPageLoading,
                        setSiteBreadcrumbs,
                        setSelected,
                        setEditableGroupSelected,
                        setSelectedGroupListName,
                        navigate
                      );
                    }}
                  >
                    {object.name}
                  </Link>
                );
              } else if (index === 4 && siteBreadcrumbs.length > 5) {
                return (
                  <Link
                    underline="hover"
                    key={index}
                    color="inherit"
                    href="#"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Mulish",
                      fontWeight: "bold",
                    }}
                    variant="h5"
                    onClick={() => {
                      setSelectedIndex({
                        level1: [siteBreadcrumbs[0].id],
                        level2: [siteBreadcrumbs[1].id],
                        level3: [siteBreadcrumbs[2].id],
                        level4: [siteBreadcrumbs[3].id],
                        level5: [object.id],
                        level6: [],
                      });
                      setPageLoading(true);
                      localStorage.setItem("getIndividualGroupId", object.id);
                      setSearchGroupId(object.id);
                      getIndividualGroup(
                        object.id,
                        setRenderedRows,
                        setPageLoading,
                        setSiteBreadcrumbs,
                        setSelected,
                        setEditableGroupSelected,
                        setSelectedGroupListName,
                        navigate
                      );
                    }}
                  >
                    {object.name}
                  </Link>
                );
              } else if (index === 5 && siteBreadcrumbs.length > 6) {
                return (
                  <Link
                    underline="hover"
                    key={index}
                    color="inherit"
                    href="#"
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Mulish",
                      fontWeight: "bold",
                    }}
                    variant="h5"
                    onClick={() => {
                      setSelectedIndex({
                        level1: [siteBreadcrumbs[0].id],
                        level2: [siteBreadcrumbs[1].id],
                        level3: [siteBreadcrumbs[2].id],
                        level4: [siteBreadcrumbs[3].id],
                        level5: [siteBreadcrumbs[4].id],
                        level6: [object.id],
                      });
                      setPageLoading(true);
                      localStorage.setItem("getIndividualGroupId", object.id);
                      setSearchGroupId(object.id);
                      getIndividualGroup(
                        object.id,
                        setRenderedRows,
                        setPageLoading,
                        setSiteBreadcrumbs,
                        setSelected,
                        setEditableGroupSelected,
                        setSelectedGroupListName,
                        navigate
                      );
                    }}
                  >
                    {object.name}
                  </Link>
                );
              } else
                return (
                  <Typography
                    key={index}
                    color="text.primary"
                    fontSize="14px"
                    fontFamily="Mulish"
                    fontWeight="bold"
                  >
                    {object.name}
                  </Typography>
                );
            })}
          {window.location.pathname.includes("patrol") &&
            siteBreadcrumbs.slice(1).map((object: any, index: any) => {
              // Capture the object for this specific button to avoid closure issues
              const currentObject = object;
              if (currentObject?.parent_account)
                return (
                  <div className="flex" key={index}>
                    <Button
                      onClick={(event) => handleClick(event, currentObject)}
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Mulish",
                        fontWeight: "bold",
                        color: "inherit",
                        textTransform: "none",
                        padding: 0,
                        minWidth: "auto",
                        "&:hover": {
                          backgroundColor: "transparent",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {currentObject.name}
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                      }}
                    >
                      <MenuItem onClick={() => handleShowSites(index)}>
                        Show Sites
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleViewEditBatchSize();
                        }}
                      >
                        View/Edit Tenant Settings
                      </MenuItem>
                    </Menu>
                  </div>
                );
              else
                return (
                  <Typography
                    key={index}
                    color="text.primary"
                    fontSize="14px"
                    fontFamily="Mulish"
                    fontWeight="bold"
                  >
                    {object.name}
                  </Typography>
                );
            })}
        </Breadcrumbs>
      </div>

      {/* Batch Size Dialog - Only show on patrol pages */}
      {window.location.pathname.includes("patrol") && (
        <TenantSettingsDialog
          open={tenantSettingsDialogOpen}
          onClose={() => setTenantSettingsDialogOpen(false)}
          navigate={navigate}
        />
      )}
    </Stack>
  );
};
